/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/scripts/components/set-klevu-page-position.js
/**
 * Component: Checks the method in which the user has navigated to the
 * Klevu search page and takes the user to the top of the page if they've
 * arrived via Browser back/forward or reload.
 *
 * This resolves an issue where te user would be greeted with the footer on load.
 * ------------------------------------------------------------------------------
 * @namespace SetKlevuSearchPosition
 */

/**
* DOM selectors.
*/
/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */
/* harmony default export */ const set_klevu_page_position = (() => {
  function checkBackPosition() {
    let hasGoneBack = false;
    if (window.performance) {
      const navEntries = window.performance.getEntriesByType('navigation');

      // Browser API v2: User has loaded via Back/Forward
      if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
        hasGoneBack = true;

        // Browser API v1: User has loaded via Back/Forward
      } else if (window.performance.navigation && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
        hasGoneBack = true;

        // Browser API v1: User has loaded via Refresh
      } else if (performance.navigation.type === 1) {
        hasGoneBack = true;
      }
    }
    if (hasGoneBack) {
      window.scroll({
        top: 0,
        left: 0
      });
    }
  }

  /**
   * Initialise component.
   */
  function init() {
    checkBackPosition();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init
  });
});
;// CONCATENATED MODULE: ./src/scripts/templates/page.search.js

document.addEventListener('DOMContentLoaded', () => {
  const kuProListing = document.getElementById('kuProListing');
  const kuFilterElem = document.getElementById('kuFilters');
  const config = {
    attributes: true,
    childList: false,
    subtree: false
  };
  const observer = new MutationObserver(mutationCallback);
  let checkScroll = false;
  function mutationCallback() {
    if (kuProListing.style.display !== 'block') {
      return;
    }
    kuProListing.style.display = 'flex';
    const showMoreElems = [...kuFilterElem.querySelectorAll('.kuShowOpt')];
    const showLessElems = [...kuFilterElem.querySelectorAll('.kuHideOpt')];
    for (const showMore of showMoreElems) {
      showMore.querySelector('a').innerText = 'View more';
      showMore.querySelector('a').setAttribute('title', 'view more');
    }
    for (const showLess of showLessElems) {
      showLess.querySelector('a').innerText = 'View less';
      showLess.querySelector('a').setAttribute('title', 'view less');
    }
    if (checkScroll === false) {
      set_klevu_page_position().init();
    }
    checkScroll = true;
  }
  observer.observe(kuProListing, config);
});
/******/ })()
;